import { invalidateSettingsCache } from './settingsCache';
import { clearCachedData } from './offlineCache';
import { clearPendingInvite } from './pendingInvite';

// Drop everything cached for the signed-in band, so the next person signing in on the
// same browser doesn't see it (settings cache, theme cache, offline gig/request cache).
export async function clearSessionData() {
  invalidateSettingsCache();
  clearPendingInvite();
  try { localStorage.removeItem('gr-theme-cache'); } catch {}
  await clearCachedData();
}
